/*
  KvD: Range-Slider fuer Listen-Filter (z. B. Akkukapazitaet).
  Shopify liefert Metafeld-Filter nur als Liste. Dieses Element blendet die Liste aus,
  zeigt stattdessen einen Slider mit zwei Griffen und setzt beim Loslassen die
  Checkboxen aller Werte im gewaehlten Bereich. Gefiltert wird weiter ueber die
  normale Shopify-Liste (OR-Verknuepfung innerhalb des Filters).
*/
(() => {
  // Schutz gegen doppeltes Einbinden (Script kann mehrfach auf der Seite stehen).
  if (window.kvdRangeListLoaded) return;
  window.kvdRangeListLoaded = true;

  class KvdRangeList extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === "1") return;
      this.dataset.ready = "1";

      this.list = this.nextElementSibling;
      if (!this.list) return;

      const items = Array.from(this.list.querySelectorAll('input[type="checkbox"]'))
        .map((box) => ({ box, num: parseFloat(String(box.value).replace(",", ".")) }))
        .filter((item) => !isNaN(item.num))
        .sort((a, b) => a.num - b.num);

      // Weniger als 2 Werte: Slider sinnlos, normale Liste zeigen.
      if (items.length < 2) {
        this.hidden = true;
        return;
      }

      this.items = items;
      this.unit = this.dataset.unit || "";
      const max = items.length - 1;
      const checked = items.map((item, i) => (item.box.checked ? i : -1)).filter((i) => i >= 0);
      const from = checked.length ? Math.min(...checked) : 0;
      const to = checked.length ? Math.max(...checked) : max;
      const label = this.dataset.label || "";

      this.innerHTML = `
        <div class="kvd-range__track">
          <input type="range" class="kvd-range__input kvd-range__input--from" min="0" max="${max}" step="1" value="${from}" aria-label="${label} von">
          <input type="range" class="kvd-range__input kvd-range__input--to" min="0" max="${max}" step="1" value="${to}" aria-label="${label} bis">
        </div>
        <div class="kvd-range__values">
          <span class="kvd-range__value kvd-range__value--from"></span>
          <span class="kvd-range__value kvd-range__value--to"></span>
        </div>`;

      this.inputFrom = this.querySelector(".kvd-range__input--from");
      this.inputTo = this.querySelector(".kvd-range__input--to");
      this.labelFrom = this.querySelector(".kvd-range__value--from");
      this.labelTo = this.querySelector(".kvd-range__value--to");

      [this.inputFrom, this.inputTo].forEach((input) => {
        // Slider-Bewegung darf das Filterformular nicht ausloesen (nur das Ergebnis beim Loslassen).
        input.addEventListener("input", (event) => {
          event.stopPropagation();
          this.clamp(input);
          this.update();
        });
        input.addEventListener("change", (event) => {
          event.stopPropagation();
          this.clamp(input);
          this.update();
          this.apply();
        });
      });

      this.update();
    }

    clamp(changed) {
      const from = Number(this.inputFrom.value);
      const to = Number(this.inputTo.value);
      if (from > to) {
        if (changed === this.inputFrom) this.inputFrom.value = to;
        else this.inputTo.value = from;
      }
    }

    format(num) {
      return `${num.toLocaleString("de-DE")}${this.unit ? " " + this.unit : ""}`;
    }

    update() {
      const max = this.items.length - 1;
      const from = Number(this.inputFrom.value);
      const to = Number(this.inputTo.value);
      this.labelFrom.textContent = this.format(this.items[from].num);
      this.labelTo.textContent = this.format(this.items[to].num);
      this.style.setProperty("--kvd-range-min", `${(from / max) * 100}%`);
      this.style.setProperty("--kvd-range-max", `${(to / max) * 100}%`);
      // Oberen Griff nach vorne holen, wenn beide ganz rechts stehen.
      this.inputFrom.style.zIndex = from === max ? 3 : "";
    }

    apply() {
      const max = this.items.length - 1;
      const from = Number(this.inputFrom.value);
      const to = Number(this.inputTo.value);
      const full = from === 0 && to === max;

      this.items.forEach((item, i) => {
        item.box.checked = !full && i >= from && i <= to;
      });

      // Filter wie bei einem normalen Checkbox-Klick ausloesen.
      const trigger = this.items[0].box;
      trigger.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  if (!customElements.get("kvd-range-list")) {
    customElements.define("kvd-range-list", KvdRangeList);
  }

  /*
    Welche Filter als Slider dargestellt werden: Parametername -> Einheit + Label.
    Der Slider wird automatisch vor die jeweilige Liste gesetzt (Desktop + Mobile)
    und nach jedem Neuladen der Filter (AJAX) wieder eingefuegt.
  */
  const KVD_RANGE_FILTERS = {
    "filter.p.m.custom.filter_akkukapazitaet": { unit: "Wh", label: "Akkukapazität" },
  };

  function kvdInjectRangeLists() {
    Object.keys(KVD_RANGE_FILTERS).forEach((param) => {
      const config = KVD_RANGE_FILTERS[param];
      const lists = new Set();
      document.querySelectorAll(`input[type="checkbox"][name="${param}"]`).forEach((box) => {
        const list = box.closest("ul");
        if (list) lists.add(list);
      });
      lists.forEach((list) => {
        const prev = list.previousElementSibling;
        if (prev && prev.tagName === "KVD-RANGE-LIST") return;
        const el = document.createElement("kvd-range-list");
        el.className = "kvd-range";
        el.dataset.unit = config.unit;
        el.dataset.label = config.label;
        list.parentNode.insertBefore(el, list);
      });
    });
  }

  let kvdRangeScheduled = false;
  function kvdScheduleInject() {
    if (kvdRangeScheduled) return;
    kvdRangeScheduled = true;
    requestAnimationFrame(() => {
      kvdRangeScheduled = false;
      kvdInjectRangeLists();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", kvdInjectRangeLists);
  } else {
    kvdInjectRangeLists();
  }
  new MutationObserver(kvdScheduleInject).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();